import Box from 'carbon-react/esm/components/box';
import Button from 'carbon-react/esm/components/button/__next__';
import { NotificationMessage } from '../../../components/NotificationMessage';
import { useDsnActions } from '../hooks/useDsnActions';
import type { DownloadButtonProps } from '../types/downloadbutton.types';

const DownloadButton = ({ selectedRows, data }: DownloadButtonProps) => {
  const { handleMultipleDownload, downloadLoading, notification } = useDsnActions();

  const selectedDownloadableInstanceIds = Object.entries(selectedRows)
    .filter(([instanceId, isSelected]) => {
      const item = data.find(row => row.InstanceId === instanceId);
      return isSelected && item && (item.DisplayPdfImg || item.DisplayZipImg);
    })
    .map(([instanceId]) => instanceId);

  return (
    <>
      <NotificationMessage
        open={notification.showNotification}
        onDismiss={notification.hideNotification}
        variant={notification.notificationVariant}
      >
        {notification.notificationMessage}
      </NotificationMessage>

      <Box display="flex" justifyContent="flex-end" mb={2}>
        <Button
          onClick={() => void handleMultipleDownload(selectedDownloadableInstanceIds)}
          disabled={selectedDownloadableInstanceIds.length === 0 || downloadLoading}
          iconType="download"
          iconPosition="before"
        >
          {downloadLoading ? 'Téléchargement en cours...' : 'Télécharger les bilans'}
        </Button>
      </Box>
    </>
  );
};

export default DownloadButton;
